import React from "react";
import StarIcon from "@material-ui/icons/Star";
import { NavLink } from "react-router-dom";

function Featured({ data }) {
  return (
    <>
      <section className="bg-light">
        <div className="container py-5">
          <div className="row text-center py-3">
            <div className="col-lg-6 m-auto">
              <h1 className="h1">Featured Product</h1>
              <p>
                Reprehenderit in voluptate velit esse cillum dolore eu fugiat
                nulla pariatur. Excepteur sint occaecat cupidatat non proident.
              </p>
            </div>
          </div>
          <div className="row">
            {data.map((dat) => {
              return (
                <div className="col-12 col-md-4 mb-4" key={dat.id}>
                  <div className="card h-100">
                    <NavLink to="/ProductDetails">
                      <img
                        src={dat.Fimg}
                        className="card-img-top"
                        alt="..."
                      />
                    </NavLink>
                    <div className="card-body">
                      <ul className="list-unstyled d-flex justify-content-between">
                        <li>
                          <StarIcon className="text-warning" />
                          <StarIcon className="text-warning" />
                          <StarIcon className="text-warning" />
                          <StarIcon className="text-muted" />
                          <StarIcon className="text-muted" />
                        </li>
                        <li className="text-muted text-right">${dat.price}</li>
                      </ul>
                      <NavLink
                        to="/ProductDetails"
                        className="h2 text-decoration-none text-dark"
                      >
                       {dat.Ftitle}
                      </NavLink>
                      <p className="card-text">
                       {dat.Description}
                      </p>
                      <p className="text-muted">Reviews {dat.reviews}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
}

export default Featured;
